
import {
  apiZwStoreLists,
  apiZwAsyncLists,
  apiAsyncStoreProducts,
  apiAsyncCost,
  apiGetAsyncMsg
} from "@/api/shop";
import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import ExportData from "@/components/export-data/index.vue";
import { RequestPaging } from "@/utils/util";
import LsDialog from "@/components/ls-dialog.vue";
import DatePicker from "@/components/date-picker.vue";
@Component({
  components: {
    lsPagination,
    LsDialog,
  },
})

export default class ZwStoreList extends Vue {
  listData: any = [];
  isLoading = false;
  pager: RequestPaging = new RequestPaging();
  searchObj = {}
  queenMsg: any = [];
  msgDialogShow = false;

  apiZwAsyncLists = apiZwAsyncLists
  //获取更新记录信息
  async getLogLists(){
    this.pager.request({
          callback: apiZwAsyncLists,
          params: {
            ...this.searchObj
          },
      });
  }
  // 获取商城列表，
  async getZwStoreLists() {
    apiZwStoreLists().then((res: any) => {
          this.isLoading = false;
          this.listData = res
      })
      .catch((e) => {
          this.$message.error('数据初始化失败，请刷新重载！')
      })
  }


  // 同步商城的商品信息
  async onStoreAsync(row: any): Promise<void> {
    const ret = await apiAsyncStoreProducts({ storeId: row.id });
    const taskId = ret.taskId;
    this.queenMsg = [];
    this.msgDialogShow = true;
    this.getMsgList(taskId);
  }
  // 同步成本信息
  async onProductAsync(row: any): Promise<void> {
    const ret = await apiAsyncCost({ storeId: row.id });
    const taskId = ret.taskId;
    this.queenMsg = [];
    this.msgDialogShow = true;
    this.getMsgList(taskId);
  }
  getMsgList(taskId: any) {
    const that = this;
    setTimeout(async function(){
      const ret = await apiGetAsyncMsg({taskId});
      ret.list.forEach((e: any) => {
        that.queenMsg.push(e);
      });
      if(that.queenMsg.length > 25){
        const diff = that.queenMsg.length - 25;
        for(var i = 0; i < diff; i++){
          that.queenMsg.shift();
        }
      }
      if(that.msgDialogShow){
        that.getMsgList(taskId);
      }else{
        that.getLogLists();
      }
    }, 300);
  }

  // 去编辑商城
  toSetMealEdit(id: number | any): void {
    this.$router.push({
      path: "/shop/zw_store_edit",
      query: {
        id: id,
      },
    });
  }

  created() {
    this.getZwStoreLists();
    this.getLogLists();
  }
}
